module.exports = "<app-chitfundmenu></app-chitfundmenu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/chitfund.component.html
// module id = ./src/app/chitfund/chitfund.component.html
// module chunks = main